import tick from "../../assets/icons/tick-thick.svg";
import { useEffect, useRef, useState } from "react";
import getClassName from "../../utilities/getClassName";
import { CSSTransition } from "react-transition-group";

const QuoteFilters = ({ showFilters, selectedFilter, filterBarRef, filtersButtonRef }) => {
    const [filterOptions, setFilterOptions] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    const filterToggleHandler = (filter) => {
        const updatedFilters = { ...filterOptions, [filter]: !filterOptions[filter] };
        setFilterOptions(updatedFilters);
        selectedFilter(updatedFilters);
    };

    const quoteFilters = useRef(null);

    useEffect(() => {
        if (!showFilters || !filtersButtonRef?.current) {
            return;
        }

        const updateDropdownPosition = () => {
            const buttonRect = filtersButtonRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: buttonRect.bottom + 8,
                left: buttonRect.left,
            });
        };

        updateDropdownPosition();
        window.addEventListener("resize", updateDropdownPosition);
        window.addEventListener("scroll", updateDropdownPosition, true);

        return () => {
            window.removeEventListener("resize", updateDropdownPosition);
            window.removeEventListener("scroll", updateDropdownPosition, true);
        };
    }, [showFilters, filtersButtonRef]);

    return (
        <CSSTransition
            nodeRef={quoteFilters}
            in={showFilters}
            timeout={500}
            classNames={{
                enterDone: "quote-filters--active",
                enterActive: "quote-filters--transition-in",
                exitActive: "quote-filters--transition-out",
            }}
        >
            <div
                ref={quoteFilters}
                className={getClassName(["quote-filters"])}
                style={{ top: `${dropdownPosition.top}px`, left: `${dropdownPosition.left}px` }}
            >
                <div ref={filterBarRef} className="quote-filters__row">
                    <button onClick={() => filterToggleHandler("wifi")} className="quote-filters__filter">
                        <span className="quote-filters__filter__check-box">
                            {filterOptions.wifi && <img src={tick} alt="" />}
                        </span>
                        WiFi
                    </button>
                    <button onClick={() => filterToggleHandler("toilet")} className="quote-filters__filter">
                        <span className="quote-filters__filter__check-box">
                            {filterOptions.toilet && <img src={tick} alt="" />}
                        </span>
                        Toilets
                    </button>
                    <button onClick={() => filterToggleHandler("hotGalley")} className="quote-filters__filter">
                        <span className="quote-filters__filter__check-box">
                            {filterOptions.hotGalley && <img src={tick} alt="" />}
                        </span>
                        Hot Galley
                    </button>
                    <button onClick={() => filterToggleHandler("bed")} className="quote-filters__filter">
                        <span className="quote-filters__filter__check-box">
                            {filterOptions.bed && <img src={tick} alt="" />}
                        </span>
                        Bed
                    </button>
                </div>
            </div>
        </CSSTransition>
    );
};

export default QuoteFilters;
